import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RequestPasswordComponent } from '@pacifico/business/auth-flow/components/request-password/request-password.component';
import { RequestPaswordPageComponent } from './request-pasword-page.component';
import { ContentAuthModule } from '@pacifico/business/auth-flow/components/content-auth/content-auth.module';
import { ValidateDataComponent } from '@pacifico/business/auth-flow/components/validate-data/validate-data.component';
import { SharedFormModule } from '@pacifico/shared/shared-forms.module';
import { SharedComponentsModule } from '@pacifico/shared/shared-components.module';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [RequestPasswordComponent, RequestPaswordPageComponent, ValidateDataComponent],
	imports: [CommonModule, ContentAuthModule, SharedFormModule, SharedComponentsModule, RouterModule],
	exports: [RequestPaswordPageComponent],
	providers: [DatePipe]
})
export class RequestPaswordPageModule {}
